"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_DATA_URL_KEY = exports.INIT_MAX_NUMBER = exports.DEFAULT_NULL_INDEX = void 0;
exports.DEFAULT_NULL_INDEX = -1;
exports.INIT_MAX_NUMBER = 1000;
exports.DEFAULT_DATA_URL_KEY = 'dataURL';
//# sourceMappingURL=constants.js.map